import {WizardStep} from './wizard-step';

export class WizardGroup {
    constructor(
        public title: string,
        public steps: WizardStep[] = [],
        private buttonName?: string
    ) {
        if (this.steps.length > 1) {
            this.steps.forEach(step => {
                step.groupTitle = this.title;
                if (this.buttonName) {
                    step.groupButtonName = this.buttonName;
                }
            });
        }
    }

    get active(): boolean {
        return this.steps.some(s => s.active);
    }

    get visible(): boolean {
        return this.steps.some(s => s.visible);
    }

    get touched(): boolean {
        return this.steps.filter(step => step.visible).every(s => s.touched);
    }

    get valid(): boolean {
        return this.steps.filter(step => step.visible).every(s => s.valid);
    }

    get visibleSteps(): WizardStep[] {
        return this.steps.filter(step => step.visible);
    }
}
